import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPlusXSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.62012 7.40558H12V8.65558H8.62012V12.0355H7.37012V8.65558H4V7.40558H7.37012V4.03546H8.62012V7.40558Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlusXSmall);
const Memo = memo(ForwardRef);
export default Memo;
